import { VueSlideToggle } from "vue-slide-toggle";
import { mapGetters } from "vuex";

export default {
    name: "CosmoBaseFaq",
    props: {},
    emits: [],
    components: { VueSlideToggle },
    setup() {},
    data() {
        return {
          openedSlide: []
        }
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "cosmobase/content",
      }),
    },
    methods: {
      isSlideOpen(index) {
        return this.openedSlide.includes(index)
      },
      openSlide(index) {
        const arrayIndex = this.openedSlide.indexOf(index);
        if (arrayIndex !== -1) {
          this.openedSlide.splice(arrayIndex, 1);
        } else {
          this.openedSlide.push(index);
        }
      }
    }
}
